package ui.screens

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.AnimatedVisibilityScope
import androidx.compose.animation.ExperimentalSharedTransitionApi
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.MutableTransitionState
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.withFrameNanos
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import data.repository.FirebaseInvitationRepo
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import models.Wonder
import thewedding_cmp.composeapp.generated.resources.Res
import thewedding_cmp.composeapp.generated.resources.background_flower
import thewedding_cmp.composeapp.generated.resources.background_grass
import thewedding_cmp.composeapp.generated.resources.candles
import thewedding_cmp.composeapp.generated.resources.cloud_white
import thewedding_cmp.composeapp.generated.resources.dating
import thewedding_cmp.composeapp.generated.resources.engangement
import thewedding_cmp.composeapp.generated.resources.flower_pink
import thewedding_cmp.composeapp.generated.resources.gallery
import thewedding_cmp.composeapp.generated.resources.gift
import thewedding_cmp.composeapp.generated.resources.ic_book
import thewedding_cmp.composeapp.generated.resources.ic_pause
import thewedding_cmp.composeapp.generated.resources.ic_play
import thewedding_cmp.composeapp.generated.resources.icon_next
import thewedding_cmp.composeapp.generated.resources.meet
import thewedding_cmp.composeapp.generated.resources.moon
import thewedding_cmp.composeapp.generated.resources.photo_0
import thewedding_cmp.composeapp.generated.resources.photo_1
import thewedding_cmp.composeapp.generated.resources.photo_2
import thewedding_cmp.composeapp.generated.resources.photo_3
import thewedding_cmp.composeapp.generated.resources.photo_4
import thewedding_cmp.composeapp.generated.resources.photo_5
import thewedding_cmp.composeapp.generated.resources.pin_wedding
import thewedding_cmp.composeapp.generated.resources.qris
import thewedding_cmp.composeapp.generated.resources.stars
import thewedding_cmp.composeapp.generated.resources.sun
import thewedding_cmp.composeapp.generated.resources.taj_mahal
import thewedding_cmp.composeapp.generated.resources.wedding
import ui.composables.preloadImages
import ui.screens.onboarding.GateContent
import utils.AudioPlayer
import kotlin.time.ExperimentalTime

@OptIn(
    ExperimentalFoundationApi::class,
    ExperimentalSharedTransitionApi::class, ExperimentalTime::class
)
@Composable
fun EditorialScreen(
    wonder: Wonder,
    openNotInvitedScreen: () -> Unit,
    openGalleryScreen: () -> Unit,
    audioPlayer: AudioPlayer,
    animatedVisibilityScope: AnimatedVisibilityScope,
) = BoxWithConstraints(Modifier.fillMaxSize()) {
    val repo = remember { FirebaseInvitationRepo() }
    val name = GreetingByPath()
    val maxWidthLayout = maxWidth
    val showInitialLoading = rememberSaveable { mutableStateOf(true) }
    // 🔥 Gunakan MutableTransitionState (bukan boolean biasa)
    val gateVisibleState = rememberSaveable  {
        MutableTransitionState(true)
    }

    val scope = rememberCoroutineScope()

    // 🔥 Preload image sebelum user bisa buka
    val imagesReady by preloadImages(
        listOf(
            Res.drawable.background_flower,
            Res.drawable.background_grass,
            Res.drawable.sun,
            Res.drawable.photo_0,
            Res.drawable.photo_1,
            Res.drawable.photo_2,
            Res.drawable.photo_3,
            Res.drawable.photo_4,
            Res.drawable.photo_5,
            Res.drawable.cloud_white,
            Res.drawable.flower_pink,
            Res.drawable.moon,
            Res.drawable.stars,
            Res.drawable.candles,
            Res.drawable.taj_mahal,
            Res.drawable.qris,
            Res.drawable.pin_wedding,
            Res.drawable.gallery,
            Res.drawable.gift,
            Res.drawable.ic_play,
            Res.drawable.ic_pause,
            Res.drawable.icon_next,
            Res.drawable.ic_book,
            Res.drawable.meet,
            Res.drawable.dating,
            Res.drawable.engangement,
            Res.drawable.wedding
        )
    )

    LaunchedEffect(imagesReady) {
        if (imagesReady) {
            // Pastikan minimal 1 frame tampil
            withFrameNanos { }
            delay(500)
            showInitialLoading.value = false
        }
    }

    Scaffold { paddingValues ->
        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(paddingValues)
        ) {
            // ===============================
            // ✅ WeddingScreen SELALU ADA
            // ===============================
            WeddingScreen(
                backToGate = {
                    gateVisibleState.targetState = true
                },
                openNotInvitedScreen = openNotInvitedScreen,
                openGalleryScreen = openGalleryScreen,
                audioPlayer = audioPlayer,
                animatedVisibilityScope = animatedVisibilityScope,
                invitationRepo = repo,
                invitationName = name,
                maxWidth = maxWidthLayout,
                modifier = Modifier
            )

            // ===============================
            // ✅ Gate Overlay
            // ===============================
            AnimatedVisibility(
                visibleState = gateVisibleState, // 🔥 PENTING
                exit = slideOutVertically(
                    targetOffsetY = { -it },
                    animationSpec = tween(
                        durationMillis = 600,
                        easing = FastOutSlowInEasing
                    )
                )
            ) {
                GateContent(
                    initialWonder = wonder,
                    openHomeScreen = {
                        if (!imagesReady) return@GateContent
                        // 🔥 Mulai animasi dulu
                        gateVisibleState.targetState = false
                        // 🔥 Delay sedikit supaya animasi tidak bentrok audio
                        scope.launch {
                            delay(150)
                            audioPlayer.play()
                        }
                    },
                    openNotInvited = openNotInvitedScreen,
                    audioPlayer = audioPlayer
                )
            }

            // ===============================
            // ✅ Loading hanya saat preload awal
            // ===============================
            if (showInitialLoading.value) {
                Box(
                    Modifier.fillMaxSize(),
                    contentAlignment = Alignment.Center
                ) {
                    LoadingScreen(text = "Menyiapkan undangan ...")
                }
            }
        }
    }
}

@Composable
expect fun GreetingByPath(): String